import { Button, Clickable, Col, Divider, Icon, Row, Spinner2, Text } from 'components';
import { Api, getCost, theme } from 'lib';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { submit } from '../../lib';
import { Shoutout } from './components';

const SendShoutoutCheckout = ({ data, setData, handleBack, handleClose, onShoutoutPosted }) => {
  const [price, setPrice] = useState(null),
    [accepted, setAccepted] = useState(false),
    [needCard, setNeedCard] = useState(false),
    user = useSelector((state) => state.user),
    rates = useSelector((state) => state.appState.rates),
    navigate = useNavigate(),
    { t } = useTranslation(),
    dispatch = useDispatch(),
    video = data.media?.length && data.media[0],
    { currency, cards } = user.billing,
    { isMobile } = useSelector((state) => state.appState);

  const [isAPILoading, setIsAPILoading] = useState(false);

  useEffect(() => {
    getPrice();
  }, []);

  useEffect(() => {
    if (!price || cards?.length) return;
    if (!price.price) return;

    setNeedCard('UpdatePaymentWarning');
  }, [price]);

  async function handleSubmit() {
    setIsAPILoading(true);
    await submit({ dispatch, data, handleClose, onSuccess: onShoutoutPosted });
    setIsAPILoading(false);
  }

  async function getPrice() {
    const res = await Api.get(`/billing/getPricing/shoutout/${user.billing.currency || 'usd'}`);
    if (!res) return;

    dispatch({
      type: 'UPDATE_BILLING',
      payload: res.billing
    });

    setPrice(getCost(res.rates, res.billing.currency, res.pricing.price, currency));
  }

  return (
    <React.Fragment>
      <Col noFlex pos="relative" top={isMobile ? '-95px' : '-120px'} left="0">
        <Clickable onClick={handleBack}>
          <Col
            // hasBorder='2px solid #000'
            // hasRadius='32px'
            wid="40px"
            ht="80%"
            centerAll
          >
            <Icon type="arrowLeft" dimensions={16} col={theme.GREY_60} />
          </Col>
        </Clickable>
      </Col>
      <Row wid="100%" marg="24px 0 0" responsive>
        <Col marg="0 0 0 24px" wid="100%" responsive>
          <Col>
            <Shoutout data={data} user={user} video={video} />
          </Col>
          <Col>
            <Row between>
              <Col>
                <Text h2>{t('common.total')}</Text>
              </Col>

              {price ? (
                <Text h2>
                  {(price?.convertedPrice / 100).toLocaleString(undefined, {
                    style: 'currency',
                    currency: currency || 'usd'
                  })}
                </Text>
              ) : (
                <Spinner2 />
              )}
            </Row>
            <Divider marg="32px 0 0" />
            <Row marg="32px 0 0" centerAll>
              <Clickable onClick={() => setAccepted(!accepted)} marg="0 8px 0 0">
                <Col
                  wid={accepted ? '32px' : '30px'}
                  ht={accepted ? '32px' : '30px'}
                  bg={accepted && theme.SECONDARY}
                  noFlex
                  hasRadius="32px"
                  border={!accepted && `2px solid ${theme.GREY_60}`}
                  centerAll
                >
                  {accepted && <Icon type="check" col="#fff" dimensions={16} />}
                </Col>
              </Clickable>

              <Text b2 col={theme.GREY_60}>
                {t('add.iAcceptTerms')}
              </Text>
            </Row>
            <Button
              marg="32px 0 0"
              text={t('billing.purchase')}
              disabled={!price || !accepted || needCard || isAPILoading}
              onClick={handleSubmit}
              loading={+isAPILoading}
            />
            {needCard && (
              <Col wid="100%" marg="32px 0 0">
                <Text b2>{t('billing.youNeedToAddMethod')}</Text>

                <Button
                  marg="8px 0 0"
                  text={t('billing.addPaymentMethod')}
                  onClick={() => {
                    window.open('/billing', '_blank', 'noreferrer');
                  }}
                  bordered
                />
              </Col>
            )}
          </Col>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default SendShoutoutCheckout;
